module.exports = __webpack_public_path__ + "img/dragon.eaf2d37b.png";